type RegistrationOption = {
  value: string;
  viewValue: string;
};

export const GENDER_OPTIONS: RegistrationOption[] = [
  { value: "male", viewValue: "Male" },
  { value: "female", viewValue: "Female" },
  { value: "others", viewValue: "Others" },
  { value: "no", viewValue: "Prefer not to say" },
];

export const STATUS_OPTIONS: RegistrationOption[] = [
  { value: "iit", viewValue: "IIT student/staff/alum" },
  { value: "w", viewValue: "Working" },
  { value: "othStu", viewValue: "Other Student" },
  { value: "oth", viewValue: "Other" },
];

export const COUNTRY_OPTIONS: RegistrationOption[] = [
  // { value: "ind", viewValue: "India" },
  { value: "bah", viewValue: "Bahrain" },
  { value: "kuw", viewValue: "Kuwait" },
  { value: "oman", viewValue: "Oman" },
  { value: "quatar", viewValue: "Qatar" },
  { value: "saudi", viewValue: "Saudi Arabia" },
  { value: "uae", viewValue: "The United Arab Emirates" },
  // { value: "other", viewValue: "Other" },
];

export const TRACK_OPTIONS: RegistrationOption[] = [
  // { value: "Mobility and EV", viewValue: "Mobility and EV" },
  { value: "Business", viewValue: "Business" },
  { value: "Fintech", viewValue: "FinTech" },
  { value: "Healthcare", viewValue: "Healthcare" },
  { value: "Social", viewValue: "Social" },
  // { value: "LSCM", viewValue: "Logistics, Supply Chain & Mobility" },
  // { value: "Pan IIT", viewValue: "Pan IIT" },
  
  
  // { value: "Energy", viewValue: "Energy" },
];

export const SECTOR_OPTIONS: RegistrationOption[] = [
  { value: "AI", viewValue: "Artificial Intelligence" },
  { value: "Agriculture", viewValue: "Agriculture" },
  { value: "Big Data", viewValue: "Big Data" },
  { value: "Biotech", viewValue: "Biotechnical" },
  { value: "Chemicals", viewValue: "Chemicals" },
  { value: "Consult", viewValue: "Consult" },
  { value: "DLT/Blockchain", viewValue: "DLT/Blockchain" },
  { value: "E-Commerce", viewValue: "E-Commerce and Online Market Place" },
  { value: "Edutech", viewValue: "EduTech" },
  { value: "Edge Industry", viewValue: "Edge Industry" },
  { value: "Energy", viewValue: "Greentech and Renewable Energy" },
  { value: "EV and Infrastructure", viewValue: "EV and Infrastructure" },
  { value: "FMCG", viewValue: "FMCG" },
  { value: "Fintech", viewValue: "FinTech" },
  { value: "Foodtech", viewValue: "FoodTech" },
  { value: "Hardware", viewValue: "hardware" },
  { value: "Healthcare", viewValue: "Tech Healthcare" },
  { value: "IT", viewValue: "Information Technology" },
  { value: "IoT", viewValue: "IoT" },
  { value: "Logistics", viewValue: "Logistics" },
  { value: "Manufacturing", viewValue: "Manufacturing" },
  { value: "Mobility", viewValue: "Mobility" },
  { value: "Others", viewValue: "Others" },
  { value: "SAAS", viewValue: "Software as a Service" },
  { value: "Security", viewValue: "Security" },
  { value: "Supply Chain", viewValue: "Supply Chain" },
  { value: "Wearable Tech", viewValue: "Wearable Tech" },
];

export const STATE_OPTIONS: RegistrationOption[] = [
  { value: "Other", viewValue: "Other" },
  { value: "Andhra Pradesh", viewValue: "Andhra Pradesh" },
  { value: "Arunachal Pradesh", viewValue: "Arunachal Pradesh" },
  { value: "Assam", viewValue: "Assam" },
  { value: "Bihar", viewValue: "Bihar" },
  { value: "Chhattisgarh", viewValue: "Chhattisgarh" },
  { value: "Goa", viewValue: "Goa" },
  { value: "Gujarat", viewValue: "Gujarat" },
  { value: "Haryana", viewValue: "Haryana" },
  { value: "Himachal Pradesh", viewValue: "Himachal Pradesh" },
  { value: "Jharkhand", viewValue: "Jharkhand" },
  { value: "Karnataka", viewValue: "Karnataka" },
  { value: "Kerala", viewValue: "Kerala" },
  { value: "Madhya Pradesh", viewValue: "Madhya Pradesh" },
  { value: "Maharashtra", viewValue: "Maharashtra" },
  { value: "Manipur", viewValue: "Manipur" },
  { value: "Meghalaya", viewValue: "Meghalaya" },
  { value: "Mizoram", viewValue: "Mizoram" },
  { value: "Nagaland", viewValue: "Nagaland" },
  { value: "Odisha", viewValue: "Odisha" },
  { value: "Punjab", viewValue: "Punjab" },
  { value: "Rajasthan", viewValue: "Rajasthan" },
  { value: "Sikkim", viewValue: "Sikkim" },
  { value: "Tamil Nadu", viewValue: "Tamil Nadu" },
  { value: "Telangana", viewValue: "Telangana" },
  { value: "Tripura", viewValue: "Tripura" },
  { value: "Uttarakhand", viewValue: "Uttarakhand" },
  { value: "Uttar Pradesh", viewValue: "Uttar Pradesh" },
  { value: "West Bengal", viewValue: "West Bengal" },
  {
    value: "Andaman and Nicobar Islands (UT)",
    viewValue: "Andaman and Nicobar Islands (UT)",
  },
  { value: "Chandigarh (UT)", viewValue: "Chandigarh (UT)" },
  {
    value: "Dadra and Nagar Haveli (UT)",
    viewValue: "Dadra and Nagar Haveli (UT)",
  },
  { value: "Daman and Diu (UT)", viewValue: "Daman and Diu (UT)" },
  { value: "Delhi (NCT)", viewValue: "Delhi (NCT)" },
  { value: "Jammu and Kashmir (UT)", viewValue: "Jammu and Kashmir (UT)" },
  { value: "Ladakh (UT)", viewValue: "Ladakh (UT)" },
  { value: "Lakshadweep (UT)", viewValue: "Lakshadweep (UT)" },
  { value: "Puducherry (UT)", viewValue: "Puducherry (UT)" },
];

export const BOOL_OPTIONS: RegistrationOption[] = [
  { value: "yes", viewValue: "Yes" },
  { value: "no", viewValue: "No" },
];


